export interface ThumbnailLoaderParams {
  src: string;
  width: number;
  quality?: number;
}

export function thumbnailLoader({ src, width, quality }: ThumbnailLoaderParams): string {
  const separator = src.includes("?") ? "&" : "?";
  return `${src}${separator}w=${width}&q=${quality ?? 70}`;
}
